import React from 'react';
import Header from '../../component/header/header';
import Footer from '../../component/footer/footer';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Container, Row, Col, Card, Button, ListGroup } from 'react-bootstrap';
import { motion } from 'framer-motion';
import './pricing.css';

const Pricing = () => {
  const plans = [
    {
      title: 'Founder',
      price: '10,000',
      description: 'For early-stage founders',
      features: ['Dedicated support', 'Monthly updates', 'Beta access', 'Priority onboarding'],
      variant: 'dark',
    },
    {
      title: 'Investor',
      price: '100,000',
      description: 'For strategic investors',
      features: ['Dedicated support', 'Monthly investor reports', 'Access to mentorship sessions', 'Early product beta access', 'Priority onboarding'],
      variant: 'primary',
    },
  ];

  return (
    <div>
      <Header />

      <div className="pricing-page">
        <section className="hero-section d-flex align-items-center justify-content-center">
          <div className="hero-overlay" />
          <Container className="text-center hero-content">
            <motion.h1
              initial={{ opacity: 0, y: -30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
              className="hero-title"
            >
              Pricing for Founders & Investors
            </motion.h1>
            <motion.p
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.4 }}
              className="hero-sub"
            >
              Flexible plans crafted to help startups scale — choose a plan that matches your ambition.
            </motion.p>
          </Container>
        </section>

        <section className="pricing-section py-5">
          <Container>
            <Row className="g-4 justify-content-center">
              {plans.map((plan, index) => (
                <Col key={index} xs={12} md={6} lg={4}>
                  <motion.div whileHover={{ scale: 1.03 }} whileTap={{ scale: 0.98 }} className={`price-card-wrap ${plan.title === 'Investor' ? 'popular' : ''}`}>
                    <Card className="price-card h-100 shadow-lg">
                      {/* {plan.title === 'Investor' && <div className="badge-popular">Most Popular</div>} */}
                      <Card.Body className="d-flex flex-column">
                        <div className="plan-header text-center mb-3">
                          <h5 className="plan-title">{plan.title}</h5>
                          <div className="plan-price">
                            <span className="currency">₹</span>
                            <span className="amount">{plan.price}</span>
                            <span className="period">/one-time</span>
                          </div>
                          <p className="small text-muted">{plan.description}</p>
                        </div>
                        <ListGroup variant="flush" className="mb-3 flex-grow-1">
                          {plan.features.map((feature, i) => (
                            <ListGroup.Item key={i} className="feature-item">{feature}</ListGroup.Item>
                          ))}
                        </ListGroup>
                        <div className="d-grid mt-3">
                          <Button variant={plan.variant} size="lg">Get {plan.title} Plan</Button>
                        </div>
                      </Card.Body>
                    </Card>
                  </motion.div>
                </Col>
              ))}
            </Row>
          </Container>
        </section>
      </div>

      <Footer />
    </div>
  );
};

export default Pricing;
